<template>
	<div>
		<div class="loginBox">
			<h1>请输入你的手机号</h1>
			<form>
				<input class="inp" type="number" placeholder="请输入绑定的手机号" v-model.number.trim="mobile" oninput="if(value.length > 11)value = value.slice(0, 11)" />
				<div class="pub_list">
					<div class="pub_list_bd">
						<input class="inp" type="number" placeholder="请输入验证码" v-model.number.trim="code" />
					</div>
					<span class="getYzmBtn" :class="codeValue.indexOf('s') != -1 ? 'grey' : ''" @click="getYzm">{{codeValue}}</span>
				</div>
				<div class="agreeBox"><label><input type="checkbox" name="agree" @click="agreeFn" :checked="isAgree">我已阅读并同意</label><a @click="toLink">《绑定协议》</a></div>
				<input class="long-btn" type="button" value="确定绑定" @click="submit"/>
			</form>
		</div>
		<div v-show="isLink">
			<router-view ></router-view>
		</div>
		
		
		<!--提示框-->
		<v-tips :isshow="tipshow" :tips="tips"></v-tips>
		
		<!--白底遮层-->
		<div class="witheBg" v-show="witheBgShow">
			<img src="../../assets/loading.gif" />
		</div>
		
		<!--EN公众号二维码弹层-->
		<div class="codeMask" style="z-index: 101;" v-show="publicCodeShow">
			<div class="cont">
				<img src="../../../static/publicCode.jpg" />
				<p>请先关注微信公众号</p>
			</div>
		</div>
		
		<!--是否退款弹窗-->
		<v-askpopup :askpopup="askpopup" @cancel="refundCancel" @confirm="refundConfirm"></v-askpopup>
	</div>
</template>

<script>
	import vTips from "../../common/tip"
	import api from "../../api/api"
	import vAskpopup from "../../common/askpopup"
	
	//计时器
	function timeFn (count,callback){
		var timeInterval = setInterval(() => {
			count--;
			if (count <= 0) {
				clearInterval(timeInterval);
			}
			callback(count);
		}, 1000);
	};

	export default {
		data () {
			return {
				tipshow:false,
				tips:'',
				askpopup:{
					title:'退款',
					tips:'你确定要退款吗？',
					show:false
				},
				codeValue:"获取验证码",
				mobile:'',
				code:'',
				isAgree:false,
				witheBgShow:true,
				isLink:false,
				publicCodeShow:false,
				docno:'',
				docnoMoney:''
			}
		},
		components:{vTips,vAskpopup},
		mounted() {
			this.isLink = false;
			this.witheBgShow = true;
			try {
				localStorage.removeItem("isRefund");
			}
			catch(err) {
				
			}
			this.getInit(() => {
				var that = this;
				api.isbinding({},(res) => {
					if(res.status == 1){
						if(res.data.code == 0){ //未注册
							if(localStorage.getItem("Authorization")){
								localStorage.removeItem("Authorization");
								localStorage.removeItem("LableType");
								localStorage.removeItem("USERID");
								localStorage.removeItem("CARD");
								localStorage.removeItem("WXSDK");
							};
							that.witheBgShow = false;
						}else if(res.data.code == 1){ //已注册,去登录
							api.login({},(ret) => {
								if(ret.status == 1){
									window.__CFG.Authorization = ret.data.Authorization;
									window.__CFG.lableType = ret.data.userInfo.LABELTYPE;
									window.__CFG.CARD_N = ret.data.userInfo.CARDNO;
									localStorage.setItem("Authorization",ret.data.Authorization);
									localStorage.setItem("LableType",ret.data.userInfo.LABELTYPE);
									localStorage.setItem("USERID",ret.data.userInfo.ID);
									localStorage.setItem("CARD",ret.data.userInfo.CARDNO);
									try {
										localStorage.removeItem("WXSDK");
									}
									catch(err) {
										
									}
									// api.tipload(that,"登录成功！");
									
									//判断是否退款
									if(ret.data.refundCardInfo.status == 0){
										setTimeout(() => {
											window.location.href = window.__CFG.URL + "/card/mine";
										},500);
									}
									else if(ret.data.refundCardInfo.status == 1){ //已电话申请，未提交银行卡
										console.log("已电话申请，未提交银行卡",ret.data.refundCardInfo.status);
										that.docno = ret.data.refundCardInfo.refundCard.DOCNO;
										that.docnoMoney = ret.data.refundCardInfo.refundCard.RETPAYAMT;
										that.askpopup.title = '退款金额：￥' + ret.data.refundCardInfo.refundCard.RETPAYAMT;
										that.askpopup.show = true;
									}
									else if(ret.data.refundCardInfo.status == 2){ //已提交银行卡
									console.log("已提交银行卡",ret.data.refundCardInfo.status);
										localStorage.setItem("isRefund",true);
										setTimeout(() => {
											window.location.href = window.__CFG.URL + "/card/mine";
										},500);
									}
								}else{
									console.log("请求失败");
									api.tipload(that,ret.msg);
								}
							});
						}
					}else{
						console.log("请求失败");
						api.tipload(that,res.msg);
					};
				});
			});			
		},
		methods:{
			getInit(callback){
				callback = typeof(callback) == 'function' ? callback : function(res) {};
				var code = api.getUrlParms("code");
				if(code){
					if(localStorage.getItem("WXOPENID") && localStorage.getItem("WXOPENID") != "undefined"){
						callback();
					}else{
						api.callapi2({"code":code},(rer) => {
							if(rer.status == 1){
								if(rer.data.subscribe == 1){ //已关注过公众号
									localStorage.setItem("WXOPENID",rer.data.openid);
									localStorage.setItem("WXUNIONID",rer.data.unionid);
									localStorage.setItem("WXIMG",rer.data.headimgurl);
									window.__CFG.WX_OPENID = rer.data.openid;
									window.__CFG.WX_UNIONID = rer.data.unionid;
									window.__CFG.WX_IMG = rer.data.headimgurl;
									callback();
								}else if(rer.data.subscribe == 0){ //未关注过公众号
									this.publicCodeShow = true;
								}
							}else{
								this.$router.replace("/card/getcode");
							}
						});
					}
				}else{
					if(localStorage.getItem("WXOPENID") && localStorage.getItem("WXOPENID") != "undefined"){
						callback();
					}else{
						this.$router.replace("/card/getcode");
					}
				}
			},
			getYzm(){
				if(this.codeValue.indexOf('s') == -1){
					var that = this,
						mobile = that.mobile,
						param = {
							"phone":mobile,
							"templateId":1
						};					
					if(mobile.toString().length < 11){
						api.tipload(that,"请输入11位手机号");
						return false;
					};
					api.sendcode(param,(res) => {
						if(res.status == 1){
							api.tipload(that,res.msg);
							timeFn(60,(e) => {
								if(e > 0) {
									this.codeValue = e + 's';
								}else{
									this.codeValue = '重新获取';
								}
							});
						}else{
							console.log("请求失败");
							api.tipload(that,res.msg);
						}
					});
				}
			},
			submit(){
				var that = this, 
					mobile = that.mobile, 
					code = that.code,
					param = {
						"phone":mobile,
						"templateId":1,
						"code":code,
						"parentId":window.__CFG.ParentId,
						"unionId":window.__CFG.WX_UNIONID
					};
					
				if(mobile.toString().length < 11){
					api.tipload(that,"请输入11位手机号");
					return false;
				}else if(code.toString().length == 0){
					api.tipload(that,"请输入手机验证码");
					return false;
				};
				
				if(!that.isAgree){
					api.tipload(that,"请先阅读并同意注册协议");
					return false;
				}
				api.binding(param,(res) => {
					if(res.status == 1){
						window.__CFG.Authorization = res.data.Authorization;
						window.__CFG.lableType = res.data.userInfo.LABELTYPE;
						window.__CFG.CARD_N = res.data.userInfo.CARDNO;
						localStorage.setItem("Authorization",res.data.Authorization);
						localStorage.setItem("LableType",res.data.userInfo.LABELTYPE);
						localStorage.setItem("USERID",res.data.userInfo.ID);
						localStorage.setItem("CARD",res.data.userInfo.CARDNO);
						try {
							localStorage.removeItem("WXSDK");
						}
						catch(err) {
							
						}
						api.tipload(that,"绑定手机号成功！");
						setTimeout(() => {
							// that.$router.replace("/card/mine");
							window.location.href = window.__CFG.URL + "/card/mine";
						},1500);
					}else{
						console.log("请求失败");
						api.tipload(that,res.msg);
					}
				});
			},
			//协议
			agreeFn(){
				this.isAgree = !this.isAgree;
			},
			toLink(){
				this.isLink = true;
				this.$router.push("/card/agree");
			},
			//取消退款
			refundCancel(){
				this.askpopup.show = false;
				api.cancelrefund({'docno':this.docno},(res) => {
					if(res.status == 1){
						setTimeout(() => {
							window.location.href = window.__CFG.URL + "/card/mine";
						},1500);
					}
					api.tipload(this,res.msg)
				});
			},
			//确定要退款
			refundConfirm(){
				this.askpopup.show = false;
				this.$router.push('/card/refund');
			}
		}
	}
</script>

<style scoped="scoped">
	.askpopup .popup{z-index: 101;}
</style>



// WEBPACK FOOTER //
// src/components/binding/index.vue